import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { UploadCargaMasivaService } from './upload-carga-masiva.service';

@Component({
  selector: 'app-upload-carga-masiva',
  templateUrl: './upload-carga-masiva.component.html',
  styleUrls: ['./upload-carga-masiva.component.scss']
})
export class UploadCargaMasivaComponent implements OnInit {

  @Input() plantilla$: Observable<any>;
  @Input() hideButtonRegresar: boolean = false;
  @Output() regresar = new EventEmitter<any>();
  @Output() uploadFinish = new EventEmitter<any>();

  loading: boolean = false;
  form: FormGroup;
  unsubscribe: any;
  @ViewChild('inputFile', {}) inputFile: ElementRef;
  selectedFile: any = null;

  constructor(
    private uploadCargaMasivaService: UploadCargaMasivaService
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      rutaArchivo: new FormControl('')
    });
  }

  handleClickDescargaPlantilla = () => {
    if (this.plantilla$) {
      this.plantilla$.subscribe();
    }

  }

  handleCargar = () => {

  }

  handleAttachFile = () => {
    this.inputFile.nativeElement.click();
  }

  handleChangeFile = (e) => {

    const [file] = e.srcElement.files;
    if (file) {
      this.selectedFile = file;
      this.form.patchValue({
        rutaArchivo: file.name
      });
    }

  }

  handleUploadFile = () => {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      // this.store.formRegistro.asyncUploadFile(formData).subscribe((result) => {
      //   if (result.success) {
      //     this.guidTemp = result.response.Data;
      //     this.refreshGridRegistrosCorrectos();
      //     this.refreshGridRegistrosObservados();
      //     this.store.formRegistro.asyncListarGrafico(this.guidTemp).subscribe();
      //   }
      // });

      // this.uploadFinish.emit();
    }
  }

  handleDeleteFile = () => {
    if (this.selectedFile) {
      this.selectedFile = null;
      this.form.reset();
    }
  }

}
